import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { Card, Typography } from 'antd';

const { Paragraph } = Typography;

class Rules extends Component<IRootStoreProps> {
  render(): React.ReactNode {
    return (
      <Card bordered={false} title="Правила" style={{ marginBottom: 8, marginTop: 10 }}>
        <Paragraph>
          1. В качестве логина (никнейма) на сайте запрещается использовать:
          <br />
          1.1.Нецензурные или оскорбительные слова и выражения.
          <br />
          1.2.Рекламные объявления, в том числе адреса веб-сайтов. В случае нарушения этих правил ваш логин может быть
          принудительно изменен или заблокирован администрацией сайта.
          <br />
          2. На сайте запрещается:
          <br />
          2.1.Реклама, спам.
          <br />
          2.2.Ненормативная лексика (маты).
          <br />
          2.3.Оскорбления других пользователей сайта.
          <br />
          2.4.Высказывания, унижающие человеческое достоинство, разжигающие межнациональную рознь или нарушающие
          действующее законодательство РФ.
          <br />
          2.5.Запрещено просить или вынуждать пользователей проекта передавать, одалживать игровые очки.
          <br />
          2.6.Попытки выдать себя за администрацию или службу технической поддержки проекта.
          <br />
          2.7.Попытки взлома, накрутки и т.д..
          <br />
          2.8.Регистрация больше одного аккаунта.
          <br />
          2.9.Любая агитация, предложения игрокам повторно зарегистрироваться по вашей реф. ссылке
          <br />
          3.0.Предложение / участие в любых финансовых операциях в обход системы, в том числе вывод средств в обход
          системы
          <br />
          3.1.Флуд: размещение большого количества однородной, не имеющей смысла информации или смайлов Какие меры могут
          быть приняты?:
          <br />
          3.1.1Вечная блокировка.
          <br />
          3.1.2.Отключение чата/лс на 2 дня.
          <br />
          3.1.3.Отключение чата/лс на 2 дня.
          <br />
          3.1.4.Отключение чата/лс на 5 дней.
          <br />
          3.1.5.Отключение чата/лс на 2 дня.
          <br />
          3.1.6.Отключение чата/лс на 60 дней.
          <br />
          3.1.7.Вечная блокировка.
          <br />
          3.1.8.Блокировка всех аккаунтов.
          <br />
          3.1.9.Отключение чата/лс на 90 дней.
          <br />
          3.1.10.От отключения чата/лс на 10 дней, вплоть до вечной блокировки аккаунта.
          <br />
          3.1.11.Отключение чата на 1 час При повторных нарушениях будут применены более суровые меры, вплоть до вечной
          блокировки.
        </Paragraph>
      </Card>
    );
  }
}

export const RulesPage: WithoutStore = withStore(observer(Rules));
